module.exports = __webpack_public_path__ + "img/decorator-studio.9e2cedc9.png";